export default __webpack_public_path__ + "static/media/card.ecd16d18.PNG";